export default __webpack_public_path__ + "static/media/Armguards of Black Spite.a9e423f1.jpg";